import type {SettingsState} from '@src/stores/settingsSlice.ts';
import {IS_DEV} from '@src/config.ts';
import {setSettingsSlice} from '@src/stores/settingsSlice.ts';
import merge from 'lodash/merge';
import {create} from 'zustand';
import {devtools, persist} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

/**
 * Store user settings in local storage
 */
const useSettingsStore = create<SettingsState>()(
  devtools(
    persist(
      immer((set, get, store) => ({
        ...setSettingsSlice(set, get, store),
        reset: () => {
          set(store.getInitialState());
        },
      })),
      {
        name: 'pl-insights-data-settings',
        merge: (persistedState, currentState) =>
          merge(currentState, persistedState),
      },
    ),
    {name: 'acornsSettingsStore'},
  ),
);

// If you don't have the Redux DevTools Chrome extension installed,
// useStore.devtools will be undefined
if (IS_DEV && useSettingsStore.devtools) {
  useSettingsStore.devtools.cleanup();
}

export default useSettingsStore;
